import { z } from 'zod';
import { SIP_PROVIDER_VALIDATION } from '../constants';

export const validateProviderName = (
  value?: string
): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = z
    .string()
    .min(SIP_PROVIDER_VALIDATION.NAME_MIN_LENGTH, 'Name is required')
    .max(
      SIP_PROVIDER_VALIDATION.NAME_MAX_LENGTH,
      `Name must be less than ${SIP_PROVIDER_VALIDATION.NAME_MAX_LENGTH} characters`
    )
    .safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const validateProviderDescription = (
  value?: string
): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = z
    .string()
    .max(
      SIP_PROVIDER_VALIDATION.DESCRIPTION_MAX_LENGTH,
      `Description must be less than ${SIP_PROVIDER_VALIDATION.DESCRIPTION_MAX_LENGTH} characters`
    )
    .safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const validateProviderPort = (
  value?: string
): string | undefined | boolean => {
  if (value === undefined || value === '') return undefined;

  const port = Number(value);
  if (isNaN(port) || !Number.isInteger(port) || port < 1 || port > 65535) {
    return 'Port must be a number between 1 and 65535';
  }

  return undefined;
};
